import React from 'react';
import ReactDOM from 'react-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { auth0Config, validateAuth0Config } from './config/auth0';
import { clearExpiredAuthStorage } from './utils/authStorage';

// Validate Auth0 configuration
if (!validateAuth0Config()) {
  // Auth0 configuration is missing
}

// Clear expired Auth0 cache before Auth0Provider so we don't send expired tokens
clearExpiredAuthStorage();

ReactDOM.render(
  <Auth0Provider
    domain={auth0Config.domain}
    clientId={auth0Config.clientId}
    authorizationParams={auth0Config.authorizationParams}
    redirectUri={window.location.origin}
    skipRedirectCallback={window.location.pathname === '/callback'}
    cacheLocation={auth0Config.cacheLocation}
    useRefreshTokens={auth0Config.useRefreshTokens}
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
